module.exports = __webpack_public_path__ + "static/media/75258282.jpg";